<wr-new-data-table headerText="Gebäude"
                   localStorageIdentifier="property-manager-building-overview"
                   [loadItemsFunction]="loadBuildings"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToBuilding($event)"
                   [form]="form"
                   [filterOverride]="filterOverride"
                   (filterApplied)="writeMyTeamOnlyToUrl($event)"
                   [isAdmin]="false">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="fullTextSearch" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="regionSelect">Bereich</label>
          <wr-region-select id="regionSelect" formControlName="region" [fixedTenantId]="tenantId()"></wr-region-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="teamSelect">Team</label>
          <wr-team-select id="teamSelect" formControlName="team" [regionId$]="form.get('regionId')?.valueChanges" [fixedTenantId]="tenantId()"></wr-team-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="buildingClass">Gebäude Klasse</label>
          <wr-building-class-select id="buildingClass"
                                    formControlName="buildingClass"
                                    [showEmptyOption]="true">
          </wr-building-class-select>
        </div>
        <div class="filter-control-group my-team-only-filter" data-cy="my-team-only-filter">
          <label class="label" for="myTeamOnly">Team-Zuordnung</label>
          <nb-checkbox id="myTeamOnly" formControlName="myTeamOnly">Nur mein Team</nb-checkbox>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="sectionText"
    exportKey="baseData.sectionText"
    display="Adresse">
    @if (building.baseData.sectionText) {
      <div>
        {{building.baseData.sectionText}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="name"
    exportKey="baseData.name"
    display="Name">
    @if (building.baseData.name) {
      <div>
        {{building.baseData.name}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="region"
    [sortable]="false"
    exportKey="team.region.name"
    display="Bereich">
    <wr-region-badge [region]="building.team?.region"></wr-region-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="team"
    [sortable]="false"
    exportKey="team.name"
    display="Team">
    <wr-team-badge [team]="building.team"></wr-team-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="internalNumber"
    display="Interne Nummer">
    @if (building.internalNumber) {
      <div>
        {{building.internalNumber}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="area"
    exportKey="baseData.area"
    [exportDecimals]="2"
    display="Fläche">
    @if (building.baseData.area) {
      <div>
        {{building.baseData.area | number: '1.2-2'}} m²
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="buildingCondition.conditionValue"
    [exportDecimals]="2"
    display="Zustand"
    [sortable]="false">
    @if (building.buildingCondition.conditionValue; as condition) {
      <wr-building-condition [condition]="condition"></wr-building-condition>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="actions"
    display="Aktionen"
    [sortable]="false">
    <div class="action-buttons">
      <button nbButton status="info" size="tiny" (click)="navigateToEquipment($event, building.id)" [nbTooltip]="'Gebäudeausstattung'">
        <nb-icon pack="fas" icon="box"></nb-icon>
      </button>
    </div>
  </ng-template>
</wr-new-data-table>
